var map = {
	"./title-carousel.de-CH.json": 1239,
	"./title-carousel.de-DE.json": 1240,
	"./title-carousel.en-CA.json": 1241,
	"./title-carousel.en-GB.json": 1242,
	"./title-carousel.en-IN.json": 1243,
	"./title-carousel.en-ME.json": 1244,
	"./title-carousel.en-US.json": 1245,
	"./title-carousel.es-EM.json": 1246,
	"./title-carousel.es-ES.json": 1247,
	"./title-carousel.fr-BE.json": 1248,
	"./title-carousel.fr-CA.json": 1249,
	"./title-carousel.fr-CH.json": 1250,
	"./title-carousel.nl-BE.json": 1251,
	"./title-carousel.nl-NL.json": 1252,
	"./title-carousel.pl-PL.json": 1253,
	"./title-carousel.pt-BR.json": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1238;